<template>
  <b-overlay :show="loading" class="animated">
    <v-server-table
      :columns="table_config.columns"
      :options="table_config.options"
      :theme="theme"
      :ref="ref"
      id="service-question-server-table"
      class="w-100"
    />
  </b-overlay>
</template>

<script>
import Vue from "vue";
import ServiceQuestionCollection from "@/collections/lab/ServiceQuestionCollection";
import BaseServerTable from "@/components/shared/BaseServerTable";
import { ServerTable } from "vue-tables-2";

Vue.use(ServerTable);

export default {
  name: "ServiceQuestionServerTable",
  extends: BaseServerTable,
  components: {
    ServerTable
  },
  props: {
    collection: {
      type: Object,
      default: () => new ServiceQuestionCollection()
    },
    laboratory_id: {
      type: String,
      default: null
    },
    show_columns: {
      type: Array,
      default: () => ["form_level", "input_type", "label", "values"]
    },
    filterable: {
      type: Array,
      default: () => ["searchable"]
    },
    sortable: {
      type: Array,
      default: () => ["form_level", "input_type", "label", "values"]
    }
  },
  data() {
    return {
      sample_type_id: this.$route.params.sample_type_id || null,
      route_laboratory_id: this.$route.params.laboratory_id || null,
      table_config: Object.assign(this.getDefaultTableConfig(), {
        options: {
          headings: {
            form_level: "Submission Level",
            input_type: "Input Type",
            label: "Label",
            values: "Values"
          }
        }
      })
    };
  },
  computed: {
    table_laboratory_id() {
      return this.laboratory_id || this.route_laboratory_id;
    }
  },
  methods: {
    prepareCollectionFilter(filter) {
      this.sample_type_id &&
        filter.filterEquals("sample_type_id", this.sample_type_id);
      this.table_laboratory_id &&
        filter.filterEquals("laboratory_id", this.table_laboratory_id);

      return filter;
    }
  },
};
</script>
